// This is the shape sent to BE
export type TranscodeOptions = {
  resolution: ResolutionOption
  container: SupportedContainerCode
  codec: SupportedCodecCode
  overlay?: {
    text?: string
  }
}

export type TranscodeRequestData = {
  drive_uuid: string
  path: string
  options: TranscodeOptions
}

export type SelectableOption = {
  label: string
}

export type ResolutionOption = {
  height: number
  width: number
}

type ContainerAndCodecOption = {
  container: SupportedContainerCode
  codec: SupportedCodecCode
}

export type SelectableResolutionOption = SelectableOption & ResolutionOption
export type SelectableContainerAndCodecOption = SelectableOption & ContainerAndCodecOption

// mapped type generic
export type OneToMany<PropertyType extends string, FieldType extends string> = {
  [Property in PropertyType]: FieldType[]
}

// --- GET HUMAN-READABLE CODEC AND CONTAINER NAMES ---
// mapped type generic
export type NameMapping<PropertyType extends string> = {
  [Property in PropertyType]: string
}

export const codecCodeToNameMap: NameMapping<SupportedCodecCode> = {
  AV1: 'AV1', // ok
  H_264: 'AVC (H.264)',
  H_265: 'HEVC (H.265)',
  AVC_INTRA: 'AVC-Intra',
  FRAME_CAPTURE: 'Frame name', // I cannot find in among supported codecs besides the API
  MPEG2: 'MPEG-2',
  PRORES: 'Apple ProRes',
  VC3: 'VC-3',
  VP8: 'VP8',
  VP9: 'VP9',
  XAVC: 'XAVC',
}

export const containerCodeToNameMap: NameMapping<SupportedContainerCode> = {
  F4V: 'MPEG-4 Flash (.f4v)',
  M2TS: 'MPEG-2 TS',
  MXF: 'MXF (.mxf)',
  MOV: 'QuickTime (.mov)',
  WEBM: 'WebM',
  MP4: 'MPEG-4 (.mp4)',
  // MPD: 'DASH',
  // RAW: 'Raw (no container)',
  // ISMV: 'Smooth (ISMV)',
  // CMFC: 'CMAF', // is this right?
  // M3U8: 'HSL', // not sure
}

// taken straight from boto3 MC API
// https://boto3.amazonaws.com/v1/documentation/api/latest/reference/services/mediaconvert.html
export type SupportedContainerCode =
  | 'F4V' // perhaps?
  | 'M2TS'
  | 'MOV'
  | 'MP4'
  | 'MXF'
  | 'WEBM'
// | 'M3U8' // not needed
// | 'CMFC' // not needed
// | 'MPD' // not needed
// | 'ISMV' // not needed
// | 'RAW' // not needed

// taken straight from boto3 MC API
// https://boto3.amazonaws.com/v1/documentation/api/latest/reference/services/mediaconvert.html
export type SupportedCodecCode =
  | 'AV1'
  | 'AVC_INTRA'
  | 'FRAME_CAPTURE'
  | 'H_264'
  | 'H_265'
  | 'MPEG2'
  | 'PRORES'
  | 'VC3'
  | 'VP8'
  | 'VP9'
  | 'XAVC'

export type TranscodingJob = {
  owner_uuid: string
  uuid: string
  status: string
  path: string
  progress: number
  drive_uuid: string
  error_message?: string

  overlay_image_path: string
  deleted: number
  secret: string // it exists in DB, but we do not want it on the frontent. Gotta mention it in type, though, as long we control through vuex binding
}

export type TranscodingState = {
  jobs: TranscodingJob[] | null
}
